export default __webpack_public_path__ + "static/media/kokoro-1.fb551329.png";